import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

/* Normaliza la lista de años académicos que llega en /api/Dominios/dominios/{idioma}
   admitiendo tanto un array de objetos como un diccionario {id: descripcion} */
const normalizaAniosAcademicos = (datos) => {
  if (!!!datos) {
    return [];
  }

  let lista = Array.isArray(datos)
    ? datos
    : Object.entries(datos).map((d) => ({
        idAnioAcademico: d[0],
        descripcion: d[1],
      }));

  return lista
    .map((a) => {
      let id = a.idAnioAcademico !== undefined ? a.idAnioAcademico : a.id;
      return {
        id: id,
        descripcion: a.descripcion || a.nombre || a.anioAcademico || String(id),
        actual: !!(a.actual || a.esActual || a.anioActual),
      };
    })
    .sort((a, b) => b.id - a.id);
};

const dominios = {
  state: {
    dominios: {
      localidades: "",
      tipoAccionesObservacion: "",
      tipoSeguimientosObservacion: "",
    },
    aniosAcademicos: [],
    idAnioAcademico: null,
  },
  getters: {
    getDominios: (state) => state.dominios,
    getAniosAcademicos: (state) => state.aniosAcademicos,
    getAnioAcademico: (state) => state.idAnioAcademico,
    getLocalidades: (state) => {
      return (idProvincia) => {
        let localidades;

        if (!!state.dominios.localidades) {
          localidades = state.dominios.localidades.filter(
            (l) => l.idProvincia == idProvincia
          );
          localidades = localidades.sort(function (p1, p2) {
            return p1.descripcion < p2.descripcion ? -1 : 1;
          });
        }

        return localidades;
      };
    },
    getLocalidad: (state) => {
      return (idLocalidad) => {
        let localidad;

        if (!!state.dominios.localidades) {
          localidad = state.dominios.localidades.filter(
            (l) => l.idLocalidad == idLocalidad
          )[0];
        }
        return localidad;
      };
    },
    getDominiosOrder: (state) => {
      let dominios = new Object();

      if (!!state.dominios) {
        Object.entries(state.dominios).forEach((d) => {
          if (!!d[1]) {
            dominios[d[0]] = Object.entries(d[1]).sort(function (p1, p2) {
              return p1[1] < p2[1] ? -1 : 1;
            });
          }
        });
      }

      return dominios;
    },
  },
  actions: {
    requestDominios: ({ commit, getters, dispatch }) => {
      dispatch("requestMotivosRechazo");
    },
    requestAniosAcademicos: ({ commit, getters, dispatch }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Dominios/dominios/${getters.getLanguage}`)
          .then((response) => {
            if (!!response.data.datos) {
              commit(
                "setAniosAcademicos",
                normalizaAniosAcademicos(response.data.datos.aniosAcademicos)
              );
            }
            resolve(getters.getAnioAcademico);
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    cambiarAnioAcademico: ({ commit, getters, dispatch }, idAnioAcademico) => {
      commit("setAnioAcademico", idAnioAcademico);
      commit("loading");

      //solo pedimos los listados que el tutor tiene permiso para ver
      let peticiones = [];

      if (getters.getVeTutorados) {
        peticiones.push(dispatch("requestTutoradas"));
      }

      if (getters.getVeNoTutorados) {
        peticiones.push(dispatch("requestNoTutoradas"));
      }

      return Promise.all(peticiones)
        .then(() => commit("endLoad"))
        .catch(() => commit("endLoad"));
    },
    requestMotivosRechazo: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Dominios/motivoRechazoPracticas/${getters.getLanguage}`)
          .then((response) => {
            if (!!response.data.datos) {
              commit("setMotivosRechazo", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    requestPaises: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Dominios/paises/${getters.getLanguage}`)
          .then((response) => {
            if (!!response.data.datos) {
              commit("setPaises", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    requestProvincias: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Dominios/provincias/${getters.getLanguage}`)
          .then((response) => {
            if (!!response.data.datos) {
              commit("setprovincias", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    requestLocalidades: ({ commit, getters }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/Dominios/localidades/${getters.getLanguage}`)
          .then((response) => {
            if (!!response.data.datos) {
              commit("setLocalidades", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    requestTipoAccionesObservacion: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios
          .get("/api/Dominios/tipoAccionesObservacion")
          .then((response) => {
            if (!!response.data.datos) {
              commit("setTipoAccionesObservacion", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
    requestTipoSeguimientosObservacion: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios
          .get("/api/Dominios/tipoSeguimientosObservacion")
          .then((response) => {
            if (!!response.data.datos) {
              commit("setTipoSeguimientosObservacion", response.data.datos);
            }
          })
          .catch(function (error) {
            reject(false);
            dispatch("sendErrorServer", error.response);
          });
      });
    },
  },
  mutations: {
    setAniosAcademicos(state, data) {
      state.aniosAcademicos = data;

      // Si todavía no hay año seleccionado, seleccionamos el actual (o el más reciente)
      if (state.idAnioAcademico === null && data.length > 0) {
        let actual = data.filter((a) => a.actual)[0] || data[0];
        state.idAnioAcademico = actual.id;
      }
    },
    setAnioAcademico(state, idAnioAcademico) {
      state.idAnioAcademico = idAnioAcademico;
    },
    setMotivosRechazo(state, data) {
      state.dominios["motivoRechazoPracticas"] = data;
    },
    setprovincias(state, data) {
      state.dominios["provincias"] = data;
    },
    setLocalidades(state, data) {
      state.dominios["localidades"] = data;
    },
    setPaises(state, data) {
      state.dominios["paises"] = data;
    },
    setTipoAccionesObservacion(state, data) {
      state.dominios["tipoAccionesObservacion"] = data;
    },
    setTipoSeguimientosObservacion(state, data) {
      state.dominios["tipoSeguimientosObservacion"] = data;
    },
  },
};

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominios.js